import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'FacilityDepartments',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    computed: {
        /** فلترة قائمة الأقسام بمرفق محدد (وزارة/إدارة)؛ مركز المرفق يعتمد على نطاق المستخدم في الخادم */
        filterBranchId() {
            if (this.isFacilityCenterRole()) return null;
            const raw = this.$route && this.$route.query && this.$route.query.facilityBranchesId;
            if (raw == null || raw === '') return null;
            const n = Number(raw);
            return Number.isFinite(n) && n > 0 ? n : null;
        },
        branchNameFromQuery() {
            const q = this.$route && this.$route.query;
            return (q && q.branchName) ? String(q.branchName) : '';
        },
        statsCards() {
            return [
                this.statCard('إجمالي الأقسام', this.Statistics ? this.Statistics.count : this.pages, 'primary', 'ti ti-building-community'),
                this.statCard('الأقسام النشطة', this.Statistics ? this.Statistics.active : this.countWhere(this.Info, item => Number(item.status) === 1), 'success', 'ti ti-circle-check'),
                this.statCard('الأقسام غير النشطة', this.Statistics ? this.Statistics.notActive : this.countWhere(this.Info, item => Number(item.status) !== 1), 'danger', 'ti ti-ban'),
                this.statCard('المعروض حالياً', this.Info.length, 'info', 'ti ti-layout-list'),
            ];
        }
    },

    watch: {
        '$route.query.facilityBranchesId'() {
            this.GetInfo(1);
        },
    },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewFacilityDepartmentsUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            Info: [],
            Statistics: null,
            AddDialog: false,
            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: ''
            },
            rules: {
                Name: this.$helper.Required()
            }
        };
    },

    methods: {
        moment(date) {
            if (!date) return '------';
            return moment(date).format('DD/MM/YYYY');
        },

        /** يطابق تسمية المخزن الافتراضي للقسم في الخادم (قسم — اسم القسم)؛ نعرض التسمية القصيرة فقط لأن اسم القسم في عمود منفصل. */
        defaultWarehouseTableLabel(stockingName) {
            if (stockingName == null || stockingName === '') return '-';
            const s = String(stockingName).trim();
            if (!s) return '-';
            const sep = ' — ';
            const i = s.indexOf(sep);
            if (i === -1) return s;
            const head = s.slice(0, i).trim();
            return head || s;
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            const branchFilter = this.isFacilityCenterRole() ? null : this.filterBranchId;
            this.$blockUI.Start();
            this.$http.GetFacilityDepartments(this.pageNo, this.pageSize, this.Search, branchFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || null;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.Statistics = null;
                });
        },

        openEdit(item) {
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions || '';
        },

        submitAdd(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return false;
                }

                const payload = {
                    name: this.ruleForm.Name,
                    descriptions: this.ruleForm.Descriptions || ''
                };
                if (!this.isFacilityCenterRole()) {
                    const bid = this.filterBranchId;
                    if (!bid) {
                        this.$helper.ShowMessage('error', 'تنبيه', 'افتح أقسام مرفق محدد من شاشة المرافق الصحية ثم أضف القسم.');
                        return false;
                    }
                    payload.branchesId = bid;
                }
                this.$blockUI.Start();
                this.$http.AddFacilityDepartment(payload)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.GetInfo(1);
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseAddDepartment');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data.message || response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', (err.response && err.response.data) || 'تعذر إضافة القسم');
                    });
            });
        },

        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return false;
                }

                const payload = {
                    id: Number(this.ruleForm.Id),
                    name: this.ruleForm.Name,
                    descriptions: this.ruleForm.Descriptions || ''
                };
                this.$blockUI.Start();
                this.$http.EditFacilityDepartment(payload)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.GetInfo(this.pageNo);
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseEditDepartment');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', (err.response && err.response.data) || 'تعذر تعديل القسم');
                    });
            });
        },

        ChangeStatus(id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من تغيير حالة القسم؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية'
            }).then((result) => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.ChangeStatusFacilityDepartment(id)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.GetInfo(this.pageNo);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', (err.response && err.response.data) || 'تعذر تغيير الحالة');
                    });
            });
        },

        Delete(id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من حذف القسم؟',
                icon: 'warning',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد الحذف'
            }).then((result) => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.DeleteFacilityDepartment(id)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        this.GetInfo(this.pageNo);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', (err.response && err.response.data) || 'تعذر حذف القسم');
                    });
            });
        }
    }
};
